// eslint-disable-next-line unicorn/prevent-abbreviations
export default class ModalQueryDownloadDocsZipController {
	/* @ngInject */
	/**
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {any} downloadResult
	 */
	constructor($uibModalInstance, downloadResult) {
		this.$uibModalInstance = $uibModalInstance;
		this.result = downloadResult;
	}

	cancel() {
		this.$uibModalInstance.dismiss();
	}

	download() {
		this.$uibModalInstance.close('download');
	}
}
